export default __webpack_public_path__ + "static/media/icon_ordenar.cf488691.svg";